import { Divider } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Lender } from '/src/lib/models';

export type PortfolioSummaryProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Lender to get portfolio summary for
   */
  lender?: Lender;
};

export const PortfolioSummary: React.FC<PortfolioSummaryProps> = ({ lender, open, toggleOpen }) => (
  <SidebarItem
    title="Portfolio Summary (All-Time)"
    open={open}
    toggleOpen={toggleOpen}
    toggleTooltip="Toggles the Portfolio Summary sidebar item"
    resolved={!!lender}
  >
    <InfoItem title="Amount Invested" value={lender?.alltime.account.amountInvested} bold currency />
    <Divider />
    <InfoItem title="Current Principal Balances" value={lender?.alltime.principalBalance} currency />
    <InfoItem title="Fees Collected" value={lender?.alltime.appliedToFees} currency />
    <InfoItem title="Interest Collected" value={lender?.alltime.appliedToInterest} currency />
    <InfoItem title="Total Revenue" value={lender?.alltime.totalRevenue} currency />
    <InfoItem title="Socket Fees" value={lender?.alltime.managementFees} currency />
    <InfoItem title="Net Revenue Collected" value={lender?.alltime.netRevenue} bold currency />
    <Divider />
    <InfoItem title="Returned to Investor" value={lender?.alltime.account.amountReturned} currency />
    <InfoItem title="Holding Account Balance" value={lender?.alltime.holdingAccountBalance} bold currency />
    <Divider />
    <InfoItem title="Accrued Unpaid Deal Fees" value={lender?.alltime.feeBalance} currency />
    <InfoItem title="Accrued Unpaid Deal Interest" value={lender?.alltime.interestBalance} currency />
    <InfoItem title="Total Accrued Unpaid Revenue" value={lender?.alltime.totalUnpaidRevenue} bold currency />
  </SidebarItem>
);
